



import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Row, Col, Card, Image } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import useFetchNationalities from "../../hooks/useFetchNationalities";
import useFetchBloodGroups from "../../hooks/useFetchBloodGroups";
import useFetchReligions from "../../hooks/useFetchReligions";
import useFetchLanguages from "../../hooks/useFetchLanguages";
import { ApiUrl } from "../../../ApiUrl";
import { useLocation } from "react-router-dom";
import { MAX_REGISTRATION_UPLOAD_BYTES } from "../../utils/uploadUtils";

const StaffInfo = ({ goToTab, setAddressDetails }) => {
  // const [frontCover, setFrontCover] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { employeeDetails } = location.state || {};
  const [addressData, setAddressData] = useState(null);

  const { nationalities } = useFetchNationalities();
  const { bloodGroups } = useFetchBloodGroups();
  const { religions } = useFetchReligions();
  const { data: languages } = useFetchLanguages();
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);

  const [formData, setFormData] = useState({
    employeeId: "",
    orgId: "",
    branchId: "",
    location: "JAYDEV VIHAR",
    employeeCode: "",
    title: "",
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    placeOfBirth: "",
    maritalStatus: "", // dropdown value (ID)
    bloodGroup: "", // dropdown value (ID)
    nationality: "", // dropdown value (ID)
    religion: "", // dropdown value (ID)
    gender: "", // dropdown value (ID)
    motherTongue: "", // dropdown value (ID)
    employeeType: "", // dropdown value (ID)
    status: "Active",
    email: "",
    officeEmail: "",
    phoneNumber: "",
    emergencyContactNumber: "",
    createdBy: "",
  });

  const [frontCover, setFrontCover] = useState(null); // for the profile picture
  const fileInputRef = useRef(null);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const savedProfile = sessionStorage.getItem("staff_profile_pic_base64");
    if (savedProfile) {
      setFrontCover(savedProfile);
    }
  }, []);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId") || "";
    const branchId = localStorage.getItem("branchId") || "";
    const createdBy = sessionStorage.getItem("userId") || "0";

    const staffBasicPayload = {
      employee_id: formData.employeeId ? parseInt(formData.employeeId) : 0,
      org_id: parseInt(orgId || 0),
      branch_id: parseInt(branchId || 0),
      employee_code: formData.employeeCode || "",
      title: formData.title || "",
      first_name: formData.firstName || "",
      middle_name: formData.middleName || "",
      last_name: formData.lastName || "",
      dob: formData.dob || null,
      place_of_birth: formData.placeOfBirth || "",
      marital_status: formData.maritalStatus || "",
      blood_group: formData.bloodGroup || null,
      nationality: formData.nationality || null,
      religion: formData.religion || null,
      gender: formData.gender || "",
      mother_tongue: formData.motherTongue || null,
      employee_type: formData.employeeType || null,
      is_active: formData.status === "Active",
      email: formData.email || "",
      office_email: formData.officeEmail || "",
      phone_number: formData.phoneNumber || "",
      emergency_contact_number: formData.emergencyContactNumber || "",
      created_by: parseInt(createdBy || 0),
    };

    sessionStorage.setItem(
      "staff_registration_basic",
      JSON.stringify(staffBasicPayload)
    );
  }, [formData]);
  
  useEffect(() => {
    const clearSessionOnRefresh = () => {
      sessionStorage.removeItem("staff_profile_pic_base64");
      sessionStorage.removeItem("staff_profile_pic_name");
      sessionStorage.removeItem("staff_profile_pic_type");
    };

    window.addEventListener("beforeunload", clearSessionOnRefresh);

    return () => {
      window.removeEventListener("beforeunload", clearSessionOnRefresh);
    };
  }, []);
  // Regex rules
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  const textRegex = /^[A-Za-z\s]+$/;
  const numberRegex = /^[0-9]+$/;

  const getLatestEligibleDob = () => {
    const today = new Date();
    const year = today.getFullYear() - 16;
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Validation function
  const validate = () => {
    let newErrors = {};

    if (!formData.employeeCode || !numberRegex.test(formData.employeeCode)) {
      newErrors.employeeCode = "Employee Code must contain numbers only.";
    }

    if (!formData.firstName || !textRegex.test(formData.firstName)) {
      newErrors.firstName = "First Name must contain text only.";
    }

    if (formData.middleName && !textRegex.test(formData.middleName)) {
      newErrors.middleName = "Middle Name must contain text only.";
    }

    if (formData.lastName && !textRegex.test(formData.lastName)) {
      newErrors.lastName = "Last Name must contain text only.";
    }

    if (formData.placeOfBirth && !textRegex.test(formData.placeOfBirth)) {
      newErrors.placeOfBirth = "Place of Birth must contain text only.";
    }

    if (formData.dob && formData.dob > getLatestEligibleDob()) {
      newErrors.dob = "Employee must be at least 16 years old.";
    }

    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = "Email ID is required and must be a valid email.";
    }

    if (!formData.officeEmail || !emailRegex.test(formData.officeEmail)) {
      newErrors.officeEmail =
        "Official Email ID is required and must be a valid email.";
    }

    if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Mobile Number must be a 10-digit number.";
    }
    if (
      formData.emergencyContactNumber &&
      !/^\d{10}$/.test(formData.emergencyContactNumber)
    ) {
      newErrors.emergencyContactNumber =
        "Emergency Contact Number must be a 10-digit number.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (employeeDetails) {
      const bloodGroupObj = bloodGroups.find(
        (bg) =>
          bg.blooddesc.toLowerCase() ===
          (employeeDetails.blood_group || "").toLowerCase()
      );
      const nationalityObj = nationalities.find(
        (n) =>
          n.nationalitydesc.toLowerCase() ===
          (employeeDetails.nationality || "").toLowerCase()
      );
      const religionObj = religions.find(
        (r) =>
          r.religiondescription.toLowerCase() ===
          (employeeDetails.religion || "").toLowerCase()
      );
      const motherTongueObj = languages.find(
        (l) =>
          l.languagedesc.toLowerCase() ===
          (employeeDetails.mother_tongue || "").toLowerCase()
      );

      //  Directly use employee_type_id
      setFormData({
        employeeId: employeeDetails.id || "",
        employeeCode: employeeDetails.employee_code || "",
        title: employeeDetails.title || "",
        firstName: employeeDetails.first_name || "",
        middleName: employeeDetails.middle_name || "",
        lastName: employeeDetails.last_name || "",
        dob: employeeDetails.dob || "",
        placeOfBirth: employeeDetails.place_of_birth || "",
        maritalStatus: employeeDetails.marital_status || "",
        bloodGroup: bloodGroupObj ? bloodGroupObj.id : "",
        nationality: nationalityObj ? nationalityObj.id : "",
        religion: religionObj ? religionObj.id : "",
        gender: employeeDetails.gender || "",
        motherTongue: motherTongueObj ? motherTongueObj.id : "",

        //  Directly assign employee_type_id
        employeeType: employeeDetails.employee_type_id || "",
        status: employeeDetails.is_active === false ? "Inactive" : "Active",

        email: employeeDetails.email || "",
        officeEmail: employeeDetails.office_email || "",
        phoneNumber: employeeDetails.phone_number || "",
        emergencyContactNumber: employeeDetails.emergency_contact_number || "",
        profilePicture: employeeDetails.profile || "",
      });

      if (employeeDetails.profile) {
        setFrontCover(employeeDetails.profile);
      }
    }
  }, [
    employeeDetails,
    bloodGroups,
    nationalities,
    religions,
    languages,
    employeeTypeOptions,
  ]);

  const titleOptions = [
    { value: "mr", label: "MR" },
    { value: "ms", label: "Ms" },
    { value: "mrs", label: "Mrs" },
  ];

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const maritalStatusOptions = [
    { value: "1", label: "Single" },
    { value: "2", label: "Married" },
  ];
  const genderOptions = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ];

  const handleFrontCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > MAX_REGISTRATION_UPLOAD_BYTES) {
        alert("Profile picture must be 4MB or less.");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        try {
          setFrontCover(reader.result);
          // Keep student-like image storage pattern for API submit.
          sessionStorage.setItem("staff_profile_pic_base64", reader.result);
          sessionStorage.setItem("staff_profile_pic_name", file.name);
          sessionStorage.setItem(
            "staff_profile_pic_type",
            file.type || "image/jpeg"
          );
        } catch (error) {
          console.error("Unable to store staff profile image in sessionStorage:", error);
          alert("Profile image is too large for browser storage. Please choose a smaller image.");
          setFrontCover(null);
          sessionStorage.removeItem("staff_profile_pic_base64");
          sessionStorage.removeItem("staff_profile_pic_name");
          sessionStorage.removeItem("staff_profile_pic_type");
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const capitalizeName = (text) =>
    text
      .replace(/\s+/g, " ")
      .trimStart()
      .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

  const handleNameChange = (fieldName) => (e) => {
    const value = e.target.value;
    const normalizedValue = value === "" ? "" : capitalizeName(value);

    if (!textRegex.test(normalizedValue) && normalizedValue !== "") {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [fieldName]: normalizedValue,
    }));
  };

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}STAFF/EmployeeTypeList/`)
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "Success") {
          const options = data.data.map((item) => ({
            value: item.employee_type_id,
            label: item.employee_type,
          }));
          setEmployeeTypeOptions(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching employee types:", err);
      });
  }, []);

  //  const handleNext = () => {
  //    const requiredFields = [
  //      "bloodGroup",
  //      "nationality",
  //      "religion",
  //      "motherTongue",
  //      "employeeType",
  //    ];
  //    const missingFields = requiredFields.filter((field) => !formData[field]);

  //    if (missingFields.length > 0) {
  //      alert(`Please select: ${missingFields.join(", ")}`);
  //      return;
  //    }

  //    // Save Tab 1 data in session
  //    sessionStorage.setItem("tempFormData", JSON.stringify(formData));
  //    if (frontCover) {
  //      sessionStorage.setItem("tempFrontCover", frontCover);
  //    }

  //    goToTab(1); // Go to address tab
  //  };

  const handleNext = async () => {
     if (validate()) {
       console.log("Form submitted", formData);
       const requiredFields = [
         "bloodGroup",
         "nationality",
         "religion",
         "motherTongue",
         "employeeType",
       ];
       const missingFields = requiredFields.filter((field) => !formData[field]);

       if (missingFields.length > 0) {
         alert(`Please select: ${missingFields.join(", ")}`);
         return;
       }

       try {
         // Save form data and image
         sessionStorage.setItem("tempFormData", JSON.stringify(formData));
         const orgId = localStorage.getItem("orgId") || "";
         const branchId = localStorage.getItem("branchId") || "";
         const createdBy = sessionStorage.getItem("userId") || "0";
         const staffBasicPayload = {
           employee_id: formData.employeeId ? parseInt(formData.employeeId) : 0,
           org_id: parseInt(orgId || 0),
           branch_id: parseInt(branchId || 0),
           employee_code: formData.employeeCode || "",
           title: formData.title || "",
           first_name: formData.firstName || "",
           middle_name: formData.middleName || "",
           last_name: formData.lastName || "",
           dob: formData.dob || null,
           place_of_birth: formData.placeOfBirth || "",
           marital_status: formData.maritalStatus || "",
           blood_group: formData.bloodGroup || null,
           nationality: formData.nationality || null,
           religion: formData.religion || null,
           gender: formData.gender || "",
           mother_tongue: formData.motherTongue || null,
           employee_type: formData.employeeType || null,
           is_active: formData.status === "Active",
           email: formData.email || "",
           office_email: formData.officeEmail || "",
           phone_number: formData.phoneNumber || "",
           emergency_contact_number: formData.emergencyContactNumber || "",
           created_by: parseInt(createdBy || 0),
         };
         sessionStorage.setItem(
           "staff_registration_basic",
           JSON.stringify(staffBasicPayload)
         );

         const employeeId = formData.employeeId;
         const employeeType = formData.employeeType;

         // If both are valid, call the second API
         if (employeeId && employeeType) {
           const secondApiUrl = `${ApiUrl.apiurl}STAFF/registrationAddressDetailsRetreive/${employeeId}/${employeeType}`;
           const secondResponse = await fetch(secondApiUrl);

           if (!secondResponse.ok) {
             throw new Error("Failed to fetch address details");
           }

           const secondResult = await secondResponse.json();
           console.log("Address Details:", secondResult);

           if (secondResult.message === "Success") {
             setAddressData(secondResult.data);
             setAddressDetails(secondResult.data); // Pass to parent
           } else {
             console.warn(
               "Address API responded without success:",
               secondResult
             );
           }
         } else {
           console.warn(
             "Skipping address API. Missing employeeId or employeeType."
           );
         }

         // Proceed to next tab regardless of API result
         goToTab(1);
       } catch (error) {
         console.error("Error in handleNext:", error);
         alert("Error while proceeding to next tab: " + error.message);
         goToTab(1); // Proceed anyway if error occurs
       }
     }
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card-body">
            <div className="row  mx-2">
              <div className="col-12 custom-section-box">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                  <div className="row flex-grow-1 mt-3  mb-3">
                    <div className="col-md-3 mb-3">
                      <label htmlFor="employee-code" className="form-label">
                        Employee Code
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="employee-code"
                          className="form-control detail"
                          placeholder="Enter employee code"
                          value={formData.employeeCode}
                          // onChange={(e) =>
                          //   setFormData({
                          //     ...formData,
                          //     employeeCode: e.target.value,
                          //   })
                          // }
                          onChange={(e) => {
                            if (
                              e.target.value === "" ||
                              numberRegex.test(e.target.value)
                            ) {
                              setFormData({
                                ...formData,
                                employeeCode: e.target.value,
                              });
                            }
                          }}
                        />
                        {errors.employeeCode && (
                          <div className="invalid-feedback">
                            {errors.employeeCode}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12 col-md-1 mb-3">
                      <label htmlFor="select" className="form-label">
                        Select
                      </label>
                      <Select
                        inputId="select"
                        classNamePrefix="title-select"
                        className="detail"
                        options={titleOptions}
                        value={
                          titleOptions.find(
                            (option) =>
                              option.value.toLowerCase() ===
                              formData.title.toLowerCase()
                          ) || null
                        }
                        onChange={(selected) =>
                          setFormData({ ...formData, title: selected.value })
                        }
                      />
                    </div>

                    <div className="col-12 col-md-5 mb-3 ">
                      <label htmlFor="employee-name" className="form-label">
                        Employee Name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="employee-name"
                          className="form-control detail"
                          placeholder="Enter First name"
                          value={formData.firstName}
                          onChange={handleNameChange("firstName")}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">
                            {errors.firstName}
                          </div>
                        )}
                        <input
                          type="text"
                          className="form-control detail ms-2"
                          placeholder="Enter middle name"
                          value={formData.middleName}
                          onChange={handleNameChange("middleName")}
                        />
                        {errors.middleName && (
                          <div className="invalid-feedback">
                            {errors.middleName}
                          </div>
                        )}
                        <input
                          type="text"
                          className="form-control detail ms-2"
                          placeholder="Enter last name"
                          value={formData.lastName}
                          onChange={handleNameChange("lastName")}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="birth-date" className="form-label">
                        Date of Birth
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="date"
                          id="employee-code"
                          className={`form-control detail ${
                            errors.dob ? "is-invalid" : ""
                          }`}
                          value={formData.dob}
                          onChange={(e) => {
                            const dob = e.target.value;
                            setFormData({ ...formData, dob });
                            setErrors((prev) => ({
                              ...prev,
                              dob:
                                dob && dob > getLatestEligibleDob()
                                  ? "Employee must be at least 16 years old."
                                  : "",
                            }));
                          }}
                        />
                        {errors.dob && (
                          <div className="invalid-feedback">{errors.dob}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="birth-place" className="form-label">
                        Place of Birth
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="birth-place"
                          className="form-control detail"
                          placeholder="Enter place of birth"
                          value={formData.placeOfBirth}
                          // onChange={(e) =>
                          //   setFormData({
                          //     ...formData,
                          //     placeOfBirth: e.target.value,
                          //   })
                          // }
                          onChange={(e) => {
                            if (
                              e.target.value === "" ||
                              textRegex.test(e.target.value)
                            ) {
                              setFormData({
                                ...formData,
                                placeOfBirth: e.target.value,
                              });
                            }
                          }}
                        />
                        {errors.placeOfBirth && (
                          <div className="invalid-feedback">
                            {errors.placeOfBirth}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="birth-place" className="form-label">
                        Marital Status
                      </label>
                      <Select
                        inputId="marital-status"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={maritalStatusOptions}
                        value={maritalStatusOptions.find(
                          (option) => option.value === formData.maritalStatus
                        )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            maritalStatus: selectedOption.value, // store ID (value)
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="blood-group" className="form-label">
                        Blood Group
                      </label>

                      <Select
                        inputId="blood-group"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={bloodGroups.map((item) => ({
                          value: item.id,
                          label: item.blooddesc,
                        }))}
                        value={bloodGroups
                          .map((item) => ({
                            value: item.id,
                            label: item.blooddesc,
                          }))
                          .find(
                            (option) => option.value === formData.bloodGroup
                          )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            bloodGroup: selectedOption.value, // store ID (value)
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="nationality" className="form-label">
                        Nationality
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        inputId="nationality"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={nationalities.map((item) => ({
                          value: item.id,
                          label: item.nationalitydesc,
                        }))}
                        value={nationalities
                          .map((item) => ({
                            value: item.id,
                            label: item.nationalitydesc,
                          }))
                          .find(
                            (option) => option.value === formData.nationality
                          )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            nationality: selectedOption.value, // store ID
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="religion" className="form-label">
                        Religion
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        inputId="religion"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={religions.map((item) => ({
                          value: item.id,
                          label: item.religiondescription,
                        }))}
                        value={religions
                          .map((item) => ({
                            value: item.id,
                            label: item.religiondescription,
                          }))
                          .find((option) => option.value === formData.religion)}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            religion: selectedOption.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="gender" className="form-label">
                        Gender
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        inputId="gender"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={genderOptions}
                        value={genderOptions.find(
                          (option) => option.value === formData.gender
                        )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            gender: selectedOption.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="mother-tongue" className="form-label">
                        Mother Tongue
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        inputId="mother-tongue"
                        classNamePrefix="marital-status-select"
                        className="detail"
                        options={languages.map((item) => ({
                          value: item.id,
                          label: item.languagedesc,
                        }))}
                        value={languages
                          .map((item) => ({
                            value: item.id,
                            label: item.languagedesc,
                          }))
                          .find(
                            (option) => option.value === formData.motherTongue
                          )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            motherTongue: selectedOption.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="employee-type" className="form-label">
                        Employee Type
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        inputId="employee-type"
                        classNamePrefix="employee-type-select"
                        className="detail"
                        options={employeeTypeOptions}
                        value={employeeTypeOptions.find(
                          (option) => option.value === formData.employeeType
                        )}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            employeeType: selectedOption.value, // store ID (value)
                          })
                        }
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Select
                        inputId="status"
                        classNamePrefix="status-select"
                        className="detail"
                        options={statusOptions}
                        value={statusOptions.find(
                          (option) => option.value === formData.status
                        )}
                        onChange={(selectedOption) =>
                          setFormData({ ...formData, status: selectedOption.value })
                        }
                        styles={{
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isFocused ? "#2684ff" : "white",
                            color: state.isFocused ? "white" : "#212529",
                            cursor: "pointer",
                          }),
                        }}
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="email-id" className="form-label">
                        Email ID
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="email-id"
                          className={`form-control detail ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Enter email id"
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="official-email-id" className="form-label">
                        Official Email ID
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="official-email-id"
                          className={`form-control detail ${
                            errors.officeEmail ? "is-invalid" : ""
                          }`}
                          placeholder="Enter official email id"
                          value={formData.officeEmail}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              officeEmail: e.target.value,
                            })
                          }
                        />
                        {errors.officeEmail && (
                          <div className="invalid-feedback">
                            {errors.officeEmail}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="mobile-number" className="form-label">
                        Mobile Number
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="mobile-number"
                          className="form-control detail"
                          placeholder="Enter Mobile Number"
                          value={formData.phoneNumber}
                          // onChange={(e) =>
                          //   setFormData({
                          //     ...formData,
                          //     phoneNumber: e.target.value,
                          //   })
                          // }
                          onChange={(e) => {
                            if (
                              e.target.value === "" ||
                              /^\d{0,10}$/.test(e.target.value)
                            ) {
                              setFormData({
                                ...formData,
                                phoneNumber: e.target.value,
                              });
                            }
                          }}
                        />
                        {errors.phoneNumber && (
                          <div className="invalid-feedback">
                            {errors.phoneNumber}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label
                        htmlFor="emergency-contact-number"
                        className="form-label"
                      >
                        Emergency Contact Number
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          id="emergency-contact-number"
                          className="form-control detail"
                          placeholder="Enter Emergency Contact Number"
                          value={formData.emergencyContactNumber}
                          // onChange={(e) =>
                          //   setFormData({
                          //     ...formData,
                          //     emergencyContactNumber: e.target.value,
                          //   })
                          // }
                          onChange={(e) => {
                            if (
                              e.target.value === "" ||
                              /^\d{0,10}$/.test(e.target.value)
                            ) {
                              setFormData({
                                ...formData,
                                emergencyContactNumber: e.target.value,
                              });
                            }
                          }}
                        />
                        {errors.emergencyContactNumber && (
                          <div className="invalid-feedback">
                            {errors.emergencyContactNumber}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label htmlFor="profile-picture" className="form-label">
                        Profile Picture
                      </label>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFrontCoverChange}
                        className="form-control detail"
                      />

                      {frontCover && (
                        <Image
                          src={frontCover}
                          alt="Front Cover Preview"
                          thumbnail
                          style={{
                            marginTop: "10px",
                            width: "120px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                    <div className="d-flex justify-content-end mb-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffInfo;
